export default __webpack_public_path__ + "static/media/euro-circled.c7bbeb6c.svg";